export const VARIANT_BUTTON_MAX_WIDTH = 135;
